import { useState } from 'react';
import { Menu, Phone, Plane, X } from 'lucide-react';
import {
  SW_BRAND,
  SW_BRAND_ACCENT,
  SW_LOGO_BY,
  SW_NAV,
  SW_PHONE_DISPLAY,
  SW_PHONE_RAW,
} from '../config';

const brandBase = SW_BRAND.endsWith(SW_BRAND_ACCENT)
  ? SW_BRAND.slice(0, SW_BRAND.length - SW_BRAND_ACCENT.length)
  : SW_BRAND;

export default function SwHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="swp-header">
      <div className="swp-shell swp-header__inner">
        <a className="swp-logo" href="#swp-top">
          <span className="swp-logo__mark">
            <Plane size={17} aria-hidden />
          </span>
          <span className="swp-logo__text">
            <span className="swp-logo__name">
              {brandBase}
              <span className="swp-logo__accent">
                {brandBase === SW_BRAND ? '' : SW_BRAND_ACCENT}
              </span>
            </span>
            <span className="swp-logo__by">by {SW_LOGO_BY}</span>
          </span>
        </a>

        <nav className="swp-nav" aria-label="Page sections">
          {SW_NAV.map((item) => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>

        <a className="swp-header__call" href={`tel:${SW_PHONE_RAW}`}>
          <span className="swp-header__call-icon">
            <Phone size={16} aria-hidden />
          </span>
          <span>
            24/7 booking assistance
            <strong>{SW_PHONE_DISPLAY}</strong>
          </span>
        </a>

        <button
          type="button"
          className="swp-burger"
          aria-expanded={open}
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={20} aria-hidden /> : <Menu size={20} aria-hidden />}
        </button>
      </div>

      <div className={`swp-shell swp-drawer${open ? ' is-open' : ''}`}>
        {SW_NAV.map((item) => (
          <a key={item.href} href={item.href} onClick={() => setOpen(false)}>
            {item.label}
          </a>
        ))}
        <a href={`tel:${SW_PHONE_RAW}`} onClick={() => setOpen(false)}>
          Call {SW_PHONE_DISPLAY}
        </a>
      </div>
    </header>
  );
}
